import React from "react";
import uuidv4 from "uuid/v4";

function IconScreenMeeting() {
  const id = uuidv4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <mask
        id={`a-${id}`}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <path fill="#C4C4C4" d="M0 0h20v20H0z" />
      </mask>
      <g mask={`url(#a-${id})`} fillRule="evenodd" clipRule="evenodd">
        <path
          d="M10.021 11.958c1.168 0 2.114-.915 2.114-2.042 0-1.128-.946-2.042-2.114-2.042s-2.114.914-2.114 2.042c0 1.127.946 2.042 2.114 2.042zm0 1.256c1.886 0 3.415-1.477 3.415-3.298 0-1.822-1.529-3.298-3.415-3.298-1.886 0-3.416 1.476-3.416 3.298 0 1.821 1.53 3.298 3.416 3.298z"
          fill={`url(#paint0_linear-${id})`}
        />
        <path
          d="M10.02 5.047c-2.784 0-5.041 2.18-5.041 4.87 0 2.688 2.257 4.868 5.042 4.868.738 0 1.438-.153 2.068-.427a.66.66 0 01.86.315.62.62 0 01-.325.83 6.513 6.513 0 01-2.603.538c-3.503 0-6.343-2.742-6.343-6.125s2.84-6.125 6.343-6.125 6.343 2.742 6.343 6.125c0 1.019-.258 1.981-.715 2.828a.662.662 0 01-.877.266.618.618 0 01-.277-.847 4.712 4.712 0 00.568-2.247c0-2.689-2.258-4.869-5.042-4.869z"
          fill={`url(#paint1_linear-${id})`}
        />
        <path
          d="M10.02 2.22c-4.4 0-7.969 3.446-7.969 7.696 0 .497.049.983.142 1.453a.63.63 0 01-.517.735.65.65 0 01-.761-.5A8.697 8.697 0 01.75 9.916C.75 4.972 4.9.964 10.02.964c.847 0 1.668.11 2.45.316.346.091.55.436.455.771a.654.654 0 01-.799.44 8.247 8.247 0 00-2.105-.27zm5.165 1.001a.667.667 0 01.918-.061c1.953 1.64 3.188 4.06 3.188 6.756 0 4.944-4.15 8.952-9.27 8.952a9.408 9.408 0 01-6.638-2.702.613.613 0 01.012-.889.667.667 0 01.92.012 8.084 8.084 0 005.706 2.323c4.401 0 7.97-3.446 7.97-7.696 0-2.318-1.061-4.396-2.742-5.808a.613.613 0 01-.064-.887z"
          fill={`url(#paint2_linear-${id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear-${id}`}
          x1="10.021"
          y1="6.618"
          x2="10.021"
          y2="13.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5D8DF0" />
          <stop offset="1" stopColor="#79AEF3" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear-${id}`}
          x1="10.021"
          y1="4.416"
          x2="10.021"
          y2="15.416"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5D8DF0" />
          <stop offset="1" stopColor="#79AEF3" />
        </linearGradient>
        <linearGradient
          id={`paint2_linear-${id}`}
          x1="19.059"
          y1="6.378"
          x2="7.575"
          y2="19.276"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#95D0F7" />
          <stop offset="1" stopColor="#79AEF3" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default IconScreenMeeting;
